// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .likeDislikeDiv {
  display: inline-block;
  border: 1px solid var(--sdk-chat-window-like-border-color);
  border-radius: 50%;
  padding: 10px;
  margin-right: 5px;
  text-align: center;
  cursor: pointer;
}

.kore-chat-window .likeDislikeDiv img {
  width: 20px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/likeDislikeTemplate/likeDislikeTemplate.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,0DAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AACJ;;AACA;EACI,WAAA;AAEJ","sourcesContent":[".kore-chat-window .likeDislikeDiv{\n    display: inline-block;\n    border: 1px solid var(--sdk-chat-window-like-border-color);\n    border-radius: 50%;\n    padding: 10px;\n    margin-right: 5px;\n    text-align: center;\n    cursor: pointer;\n}\n.kore-chat-window .likeDislikeDiv img { \n    width: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
